import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Student } from '../modal/student';

interface DeleteStudentParams {
  studentId: string;
}

export const deleteStudentAPI = async (params: DeleteStudentParams) => {
  const response = await baseAPI.delete<Student>(
    `/students/${params.studentId}`,
  );
  return response.data;
};

export const useDeleteStudent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: DeleteStudentParams) => deleteStudentAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDENTS],
      });
    },
  });
};
